module.exports = __webpack_public_path__ + "media/images/components/map-icons/default-marker-42d6e95a34623eb22c261d6ca93c6da6.png";